import { Box, CircularProgress } from '@mui/material';
import { useAppContext } from 'app/AppContext';
import DefaultConsultView from 'components/form/DefaultConsultView'

import React, { useCallback, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';

import { usePerfil } from 'useAuth'
import { flog } from 'util/FileLogger';

export default function DefaultEntityConsult({
    EntityClass,
    noAddActions,
    titulo,
    extraQuery,
    routeForm,
    actionsAuth,
    showEdit,
    showDelete,
    entityName,
    ...othersProps
}) {
    const navigate = useNavigate();
    const { useSetTitle, setActionsView } = useAppContext();
    const [listData, setListData] = useState([])
    useSetTitle(titulo)
    let perfil = usePerfil()
    const [temPermissao, setTemPermissao] = useState(actionsAuth ? false : true)

    useEffect(() => {
        if (actionsAuth && perfil) {
            let usePerfilAuth = actionsAuth
            //TRANFORMA EM ARRAY            
            if (typeof usePerfilAuth === 'string' || usePerfilAuth instanceof String)
                usePerfilAuth = [usePerfilAuth]
            if (actionsAuth.includes(perfil.grupoPermissao?.uid)) {
                // console.log('exibir', route)
                setTemPermissao(true)
            } else {
                // console.log('ocultar', route)
                setTemPermissao(false)
            }
        }

        return () => { }
    }, [actionsAuth, perfil])

    const loadOptions = useCallback(async () => {
        // Carrega apenas uma vez.

        // if (listData.length === 0) {
        const result = await EntityClass.getAllQuery(extraQuery);
        setListData(result);
        // }
    }, [EntityClass, extraQuery]);

    useEffect(() => {
        loadOptions();
        return () => {

        }
    }, [loadOptions]);

    useEffect(() => {
        if (temPermissao) {
            if (!noAddActions) {
                const actions = [
                    {
                        uid: "novoForm",
                        text: "Novo",
                        iconName: "Add",
                        sequence: "10",
                        action: () => {
                            flog("NewButtom in Consult: " + routeForm);
                            navigate("/" + routeForm);
                        },
                    },
                ];
                setActionsView(actions);
            }
        }



        return () => {
            if (!noAddActions) {

                setActionsView([]);
            }
        };
    }, [navigate, routeForm, setActionsView, noAddActions, temPermissao])

    if (listData.length > 0) {
        return (
            <DefaultConsultView
                columns={EntityClass.searchColumns}
                values={listData}
                onRowClick={(item) => {
                    console.log('onRowClick item', item)
                    // flog("RowClick in Consult: " + routeForm + " - " + item.id);
                    // navigate("/" + routeForm + "?uid=" + item.id)
                }}
                showEdit={showEdit}
                showDelete={showDelete}
                routeForm={routeForm}
                EntityClass={EntityClass}
                entityName={entityName || titulo?.toLowerCase() || "item"}
                {...othersProps} />
        )
    } else {
        return (
            <Box
                sx={{ textAlign: "center", justifyContent: "center", alignItems: "center", display: "flex", height: "100%" }} >
                <CircularProgress />
            </Box>
        )
    }

}
